export function openNotification() {
  return {
    type: '@notification/OPEN',
  };
}

export function closeNotification() {
  return {
    type: '@notification/CLOSE',
  };
}
